export default __webpack_public_path__ + "static/media/testimonial1.b5c066e8.png";